import { useSelector } from "react-redux";

export const ProfileInfo = () => {
  const selector = useSelector((state) => state?.auth?.myProfile);
  const local =
    localStorage.getItem("careTechUserInfo") &&
    JSON.parse(localStorage.getItem("careTechUserInfo"));
  const myProfile = selector || local;

  const accessToke = useSelector((state) => state?.auth?.accessToke);
  const localToken = localStorage.getItem("access-token");
  const token = localToken || accessToke;

  const ifAdmin = myProfile?.userType === "ADMIN";
  return { myProfile, token, ifAdmin };
};
